import { gql } from 'urql';
import { PRODUCT } from '../client';

export const GET_LOCATIONS = gql`
  query ${PRODUCT}GetLocations($input: CustomerLocationsInput!, $first: Int, $after: String) {
    customerLocations(input: $input, first: $first, after: $after) {
      nodes {
        id
        locationExcluded
        effectivelyExcluded
        keyId
        businessName
        membershipTier
        address {
          city
          state
          postalCode
        }
        includeInAutomatedRouting
        enforceItemScanning
        isDoordash
        locationDeliveryWindow {
          startTime
          endTime
        }
        scheduledDeliveryTimeSource
        deliverWithinStoreHours
        routingCohort {
          id
          color
          name
        }
        serviceTime
        storeHoursConfirmed
        customerPickup
        printDeliverySheetEnabled
        includeFinancialsOnDeliverySheet
      }
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
